import billingCategoryAllComponent from './billing_category.all.component';

let billingCategoryAllModule = angular.module('billingCategoryAll', [])

    .component('billingCategoryAll', billingCategoryAllComponent)

    .name;

export default billingCategoryAllModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/all/index.js